import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useI18nState } from '@/lib/i18n';
import type { I18nState } from '@/lib/i18n';

const defaultState: I18nState = {
  lang: 'en',
  dir: 'ltr',
  setLang: () => {},
  t: (k) => k,
};

const I18nContext = createContext<I18nState>(defaultState);

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const value = useI18nState();
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n(): I18nState {
  return useContext(I18nContext);
}
